var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPoll = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3238 8.84331H4.67622C3.19873 8.84331 2 7.52993 2 5.91862C2 4.3073 3.19873 3 4.67622 3H13.3238C14.8013 3 16 4.3073 16 5.91862C16 7.52993 14.8013 8.84331 13.3238 8.84331ZM13.3238 11.2937H4.67622C3.773 11.2937 3.03704 12.0964 3.03704 13.0814C3.03704 14.0664 3.773 14.869 4.67622 14.869H13.3238C14.227 14.869 14.963 14.0664 14.963 13.0814C14.963 12.0964 14.227 11.2937 13.3238 11.2937ZM13.3238 10.1628C14.8013 10.1628 16 11.4701 16 13.0814C16 14.6927 14.8013 16 13.3238 16H4.67622C3.19873 16 2 14.6927 2 13.0814C2 11.4701 3.19873 10.1628 4.67622 10.1628H13.3238Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPoll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/poll.aa8ea591de808d3a55549c241f76dffa.svg";